class ProductForm extends window.HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {

        this.addToCartData = {
            id: this.querySelector('[name="id"]')?.value || null,
            quantity: parseInt(this.querySelector('[name="quantity"]')?.value) || 1,
            properties: {},
            sellingPlan: false,
            openDisabled: false
        };
        this.productData = window.eHs.product;

        this.showMoreColors();
        this.quantitySelector();
        if (this.productData.variants[0]?.title === "Default Title") {
            this.addToCart();
            return;
        }
        this.productData.options.length === 1 ? this.singleSelector() : this.multiSelector();

    }
    addToCart() {

        const addToCartButton = this.querySelector("[data-add-to-cart]");

        const selectedOption = this.productData.variants.find(variant => { return variant.id == this.addToCartData.id });
        const atcButton = this.querySelector('[data-add-to-cart]');

        const notifyProductElement = this.querySelector('[data-notify-product]');
        const isSoldOut = selectedOption?.available === false; // If the product is sold out, disable the add to cart button and show the notify me form

        if (atcButton) {
            atcButton.disabled = isSoldOut;
            atcButton.textContent = isSoldOut ? "Sold Out" : "Add to Cart";
        }

        if (notifyProductElement) {
            notifyProductElement.style.display = isSoldOut ? 'block' : 'none';
        }

        addToCartButton.addEventListener("click", event => {
            event.preventDefault();
            this.addToCartData.id ? window.eHs.cart.addToCart(this.addToCartData) : console.error("No variant selected");
        });
    }

    quantitySelector() {
        const quantityButtons = this.querySelectorAll(".quantity-selector__action");
        const input = this.querySelector(".quantity-selector__field");

        quantityButtons.forEach(button => {
            button.addEventListener("click", event => {
                event.preventDefault();
                if (button.getAttribute("data-increment") !== null) {
                    this.addToCartData.quantity += 1;
                } else if (button.getAttribute("data-decrement") !== null) {
                    if (this.addToCartData.quantity <= 1) {
                        return;
                    }
                    this.addToCartData.quantity -= 1;
                }

                input.innerHTML = this.addToCartData.quantity;
                input.setAttribute("data-quantity", this.addToCartData.quantity);
            });
        });
    }
    showMoreColors() {
        const toggle = this.querySelector(".product-select__swatches__all");
        if (!toggle) {
            return;
        }

        toggle.addEventListener("click", event => {
            event.preventDefault();
            const swatches = this.querySelector(".product-select__swatches__list");
            swatches.classList.toggle("product-select__swatches__list--expanded");

            toggle.querySelector(".show-all").classList.toggle("active");
            if (swatches.classList.contains("product-select__swatches__list--expanded")) {
                toggle.querySelector(".show-all").innerHTML = "See fewer colors";
                toggle.querySelector(".arrow-down").classList.toggle("active-arrow");
            } else {
                toggle.querySelector(".show-all").innerHTML = "See all colors";
                toggle.querySelector(".arrow-down").classList.toggle("active-arrow");
            }
        });
    }
    singleSelector() {
        const variantSelector = this.querySelector('.dropdown-menu__el') || this.querySelector('.product-select__swatches__list');

        this.addToCart();

        const stopScrolling = () => {
            document.body.classList.add('no-scroll');
        };

        const allowScrolling = () => {
            document.body.classList.remove('no-scroll');
        };

        if (variantSelector.classList.contains('dropdown-menu__el')) {
            function initVariantVisibility() {
                const selectedOption = variantSelector.options[variantSelector.selectedIndex] || null;
                const variant = this.productData.variants.find(variant => {
                    return variant.title === selectedOption.value;
                });
                this.variantVisibility(variant);
                console.log("variant visibility", variant);
            }

            // Add event listener for change event
            variantSelector.addEventListener("change", event => {
                const selectedOption = event.target.options[event.target.selectedIndex] || null;
                const optionValue = event.target.value;
                this.updateVariant(optionValue);
                allowScrolling(); // Re-enable scrolling after selection
            });

            variantSelector.addEventListener("focus", stopScrolling); // Disable scrolling when the dropdown is focused
            variantSelector.addEventListener("blur", allowScrolling); // Enable scrolling when the dropdown loses focus

            window.addEventListener("load", initVariantVisibility.bind(this));
        } else {
            const buttons = variantSelector.querySelectorAll('button');
            buttons.forEach(button => {
                button.addEventListener("click", event => {
                    event.preventDefault();
                    const optionValue = button.getAttribute('value');

                    this.updateVariant(optionValue);
                    buttons.forEach(btn => {
                        btn.classList.remove('active');
                    });
                    button.classList.add('active');
                });
            });
        }
    }

    multiSelector() {
        // this will be created later
    }

    variantVisibility(selectedOption) {
        const atcButton = this.querySelector('[data-add-to-cart]');
        const notifyProductElement = this.querySelector('[data-notify-product]');
        const klaviyoBIS = document.querySelector('[data-klaviyo-bis]');
        const isSoldOut = selectedOption.available === false;
        
        atcButton.disabled = isSoldOut;
        atcButton.textContent = isSoldOut ? "Sold Out" : "Add to Cart";
        if (notifyProductElement) {
            notifyProductElement.style.display = isSoldOut ? 'block' : 'none';
        }
        if (klaviyoBIS) {
            klaviyoBIS.style.display = isSoldOut ? 'block' : 'none';
        }
    }


    updateVariant(option, type = 'single') {
        const variantInput = this.querySelector('[name="id"]');
        if (type === 'single') {
            const variant = this.productData.variants.find(variant => {
                return variant.title === option;
            });
            this.variantVisibility(variant);
            variantInput.value = variant.id;
            this.addToCartData.id = variant.id;
            this.updatePageElements(variant);
        } else {
            return;
        }
    }

    updatePageElements(variant) {

        // Because the VUE componenet controls the images, we need to trigger a change event on the select element to change the images and visible data, we can hide the elements and trigger the values. 

        const selectedVariantText = this.querySelector('[data-selected-swatch-value]') || this.querySelector('.dropdown-menu__value');

        selectedVariantText.innerHTML = variant.title;
        const oldSelector = document.querySelector('.old_selector');
        if (selectedVariantText.classList.contains('dropdown-menu__value')) { // This is the only way to change the variant images. This is for the select dropdowns
            const select = oldSelector.querySelector('.dropdown-menu__el');
            const event = new Event('change', { bubbles: true });
            const variantTitle = variant.title.replace(/"/g, '[escaped]');
            select.value = variantTitle;
            select.dispatchEvent(event);
        } else {
            // This is for the swatches
            const buttons = oldSelector.querySelectorAll('button');
            buttons.forEach(button => {
                if (button.getAttribute('aria-label') === variant.title) {
                    button.click();
                }
            });
        }
    }

}

window.customElements.define("product-form", ProductForm);

